import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AppAside, AppContent, AppSidebar, AppFooter, AppHeader } from '../components/index'
import { CCol, CRow } from '@coreui/react-pro'
import { Helmet } from 'react-helmet'

import routes from '../routes'
import * as cusUtil from 'src/viewsCommon/CusUtil'
import * as cusUrlUtil from 'src/viewsCommon/CusUrlUtil'

const DefaultLayout = () => {
  const cid = cusUtil.getCid()
  const userPermission = cusUtil.checkUserPermission()

  switch (userPermission) {
    case 'root':
      return <AdminLayout />
    case 'admin':
      return <AdminLayout />
    case 'cadmin':
      return <AdminLayout />
    case 'cmanager':
      return <AdminLayout />
    case 'user':
      if (cid === 'passit') {
        return <EmptyLayout />
      } else {
        return <UserLayout />
      }
    default:
      // 비회원도 메뉴 조회할수 있음
      if (cid === 'pwan') {
        return <UserLayout />
      } else {
        return <EmptyLayout />
      }
  }
}

const AdminLayout = () => {
  const cid = cusUtil.getCid()

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="{cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_TITLE']}"
        />
        <title>{cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_TITLE']}</title>
      </Helmet>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light bg-opacity-50 dark:bg-transparent">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <AppContent cid={cid} />
        </div>
        <AppFooter />
      </div>
      <AppAside />
    </>
  )
}

const UserLayout = () => {
  const cid = cusUtil.getCid()

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="{cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_TITLE']}"
        />
        <title>{cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_TITLE']}</title>
      </Helmet>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light bg-opacity-50 dark:bg-transparent">
        <AppHeader layout="user" margin="n" />
        <div className="body flex-grow-1">
          <AppContent breadcrumb="n" cid={cid} />
        </div>
        <AppFooter />
      </div>
      <AppAside />
    </>
  )
}

const EmptyLayout = () => {
  const cid = cusUtil.getCid()

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="{cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_TITLE']}"
        />
        <title>{cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_TITLE']}</title>
      </Helmet>
      <AppContent breadcrumb="n" cid={cid} />
      {/* <Routes>
       <Route path="/" element={<Navigate to="login" replace />} />
     </Routes> */}
    </>
  )
}

export default DefaultLayout
